import { $Elements, Elements, BrowserEvents, Classes } from './constants';
import bootbox from 'bootbox';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Sections ----------

		$Elements.body.on('adding_to_cart', function(e, button, cart) {

			$Elements.LoadingBar.addClass(Classes.loading);

			$Elements.body.one('added_to_cart', () => {

				$Elements.LoadingBar.removeClass(Classes.loading);

				if(typeof added_to_cart_modal !== 'undefined') {

					bootbox.dialog({
						centerVertical: true,
						className: 'cart-modal',
						closeButton: false,
						message: added_to_cart_modal.content,
					});
				}

				if(cart.length) {
					const quantity = cart.find(item => item.name === 'quantity');

					if(quantity) {
						const link = $('.header-shop-links .cart span');
						const current = parseInt(link.text());
						link.text(current + parseInt(quantity.value));
					}
				}
			});
		});
	});

}(jQuery));
